























































import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { translate } from "@/services/translation/translation";
import { dataService } from "@/services/data/data-service";
import { Paginator } from "@/model/paginator";
import ProjectComponent from "../project/project.vue";
import PaginatorComponent from "../paginator/paginator.vue";
import ToggleComponent from "../toggle/toggle.vue";
import "./category.less";
import SimpleDropdownComponent from "../simple-dropdown/simple-dropdown.vue";
import {getVotingEnabledData} from "@/services/getProjectData/getProjectData";

@Component({
  components: {
    ProjectComponent,
    PaginatorComponent,
    ToggleComponent,
    SimpleDropdownComponent
  }
})
export default class category extends Vue {
  @Prop() year!: string;

  private fadeVoted :boolean = false;
  private category = dataService.categoryData.category;
  private country = dataService.categoryData.country;
  private countries = dataService.categoryData.countries;
  private voting_enabled :boolean = false;
  private subscription;

  @Watch("category")
  private categoryChanged(value) {
    dataService.categoryData.category = value;
    this.paginatedData.selectedPage =1;
    dataService.paginatedData.refreshSelection(1);
    dataService.updateProjects();

    this.countries = dataService.categoryData.countries;
    this.country = dataService.categoryData.country;


  }
  @Watch("country")
  private countryChanged(value) {
    dataService.categoryData.country = value;
    this.paginatedData.selectedPage =1;
    dataService.paginatedData.refreshSelection(1);
    dataService.updateProjects();
  }

  private paginatedData: Paginator = {
    pagesCnt: 1,
    projectsToShow: [],
    selectedPage: 0,
    itemsCnt: 0
  };

  mounted() {
    this.subscription = dataService.paginatedData.data.subscribe(event => {
      this.paginatedData = event.data;
    });
    this.voting_enabled = getVotingEnabledData();
  }

  beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  pageSelected(pageNum) {
    dataService.paginatedData.refreshSelection(pageNum);
  }



  get categories() {
    return dataService.categories;
  }

  trans(key) {
    return translate(key);
  }
}
